export const INSIGHTS = {
    SIDE_PANEL_CONTAINER: "insights-side-panel-container",
    TAB: "insights-tab",
    HELP_DESK_LINK: "insights-help-desk-link",
    TOGGLE_BUTTON: "toggle-insights-button",
    TOGGLE_BUTTON_ICON: "toggle-insights-button-icon",
    TOGGLE_BUTTON_LOADING_SPINNER: "toggle-insights-button-loading-spinner",
    COMPONENTS: {
        COLOR: "color-insights",
        STYLE: "style-insights",
        CATEGORY: "category-insights",
        SIZE: "size-insights",
    },
    PRODUCT_STYLES: {
        CARD: "product-insight-card",
        RANK: "product-insight-rank",
        IMAGE: "product-insight-image",
        NAME: "product-insight-name",
        STYLE_NUMBER: "product-insight-style-number",
        COLOR: "product-insight-color",
        CATEGORY: "product-insight-category",
        ADD_TO_CART: "product-insight-add-to-cart",
        CART_ICON: "product-insight-cart-icon",
        MSRP_PRICE: "product-insight-msrp-price",
        WHOLESALE_PRICE: "product-insight-wholesale-price",
    },
    CATEGORIES: {
        ROW: "category-insight-row",
        NAME: "category-insight-name",
        PERCENTAGE: {
            LAST_YEAR: "category-insight-percentage-last-year",
            THIS_YEAR: "category-insight-percentage-this-year",
            YEARLY_CHANGE: "category-insight-percentage-yearly-change",
        },
        ARROW_DROP_UP: "category-insight-arrow-drop-up",
        ARROW_DROP_DOWN: "category-insight-arrow-drop-down",
        LAST_YEAR_INFO_ICON: "category-insight-last-year-info-icon",
        THIS_YEAR_INFO_ICON: "category-insight-this-year-info-icon",
    },
    COLOR: {
        RANK: "color-insights-rank",
        NAME: "color-insights-name",
        NO_COLORS: "color-insights-no-colors",
        INFO: "color-insights-info",
        BADGE: "color-insights-badge",
    },
    SIZES: {
        LOADING_SPINNER: "size-insight-loading-spinner",
    },
};
